import { BlockConfigurationObject } from "../interfaces/block-configuration-object.interface";

/* @ngInject */
const generalConfig = function($sceDelegateProvider: angular.ISCEDelegateProvider): void {
	$sceDelegateProvider.resourceUrlWhitelist([
		`${process.env.BLOCK_DOMAIN}/**`,
		`${process.env.CDN_DOMAIN}/**`
	]);
};

function addGTMTag(config: BlockConfigurationObject): void {
	let gtmCode;
	if (config.publicationTheme === "pickswise") {
		if (window.location.hostname === "www.pickswise.com") {
			gtmCode = "GTM-P3J2ZF5";
		} else {
			gtmCode = "GTM-5KRGW9M";
		}
	} else if (["dimers", "dimers2"].includes(config.publicationTheme)) {
		if (window.location.hostname === "www.dimers.com") {
			gtmCode = "GTM-PHQT5SM";
		} else {
			gtmCode = "GTM-NXGLSDM";
		}
	} else if (config.publicationTheme === "footyology") {
		gtmCode = "GTM-TWS935L";
	} else if (config.publicationTheme === "wwos") {
		gtmCode = "GTM-TLNKMPZ";
	} else if (config.publicationTheme !== "onetwenty") {
		gtmCode = "GTM-WR5JMKT";
	}

	if (gtmCode) {
		const gtmText = `(function (w, d, s, l, i) {
			w[l] = w[l] || []; w[l].push({
				'gtm.start':
					new Date().getTime(), event: 'gtm.js'
			}); var f = d.getElementsByTagName(s)[0],
				j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
					'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
				})(window, document, 'script', 'dataLayer', '${gtmCode}');`;
	
		if (!Array.from(document.scripts).some(s => s.textContent === gtmText)) {
			const gtmScript = document.createElement("script");
			const gtmNode = document.createTextNode(gtmText);
			gtmScript.appendChild(gtmNode);
			document.head.appendChild(gtmScript);
		}
	}

	
}

function displayErrorMessage(element: Element): void {
	element.innerHTML = `
		<div style="padding: 10px; display: flex; flex-direction: column; justify-content: center; align-items: center;width: 100%; text-align: center;">
			<b style="margin-bottom: 5px;">Error loading widget</b>
			<span>We are working to fix this issue</span>
		</div>
	`;
}

function loadScript(src: string, defer: boolean, targetElement: Element): Promise<void> {
	if (!targetElement) {
		targetElement = document.head;
	}
	return new Promise(function (resolve, reject) {
		const s = document.createElement("script");
		s.src = src;
		s.onload = () => resolve();
		s.onerror = reject;
		s.async = false;
		if (defer) s.defer = true;
		if (!Array.from(document.scripts).some(scr => scr.src === s.src)) {
			targetElement.appendChild(s);
		} else {
			resolve();
		}
		
	});
}

function loadStylesheet(src: string, targetElement: Element): Promise<unknown> {
	if (!targetElement) {
		targetElement = document.head;
	}
	return new Promise(function (resolve, reject) {
		const s = document.createElement("link");
		s.href = src;
		s.rel = "stylesheet";
		s.onload = resolve;
		s.onerror = reject;
		targetElement.appendChild(s);
	});
}

// const rollbarConfig = function(RollbarProvider: any): void {
// 	RollbarProvider.init({
// 		accessToken: "24003f3b333d42089dd4e595b80b765f",
// 		captureUncaught: true,
// 		payload: {
// 			environment: "live",
// 			source_map_enabled: true,
// 			code_version: "1.3.112",
// 		},
// 		hostSafeList: ["content-blocks-", "statsinsider.com.au", "node_modules/@hypometer"],
// 		ignoredMessages: ["unknown", "^Script error.$"]
// 	});
// };

export {generalConfig, /*rollbarConfig,*/ loadScript, loadStylesheet, displayErrorMessage, addGTMTag};